import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { WebMenuNode } from 'app/com/ibm/tw/commons/beans/web.menu.node';
import { EventData, StatusService } from 'ui-components/common';
import { DomHandler } from 'ui-components/dom';
import { ValidatorService } from 'ui-components/validator';
import { AxthenticationService } from '../../../../../services/axthentication.service';

declare function closeAllPopupPanel(): void;

@Component({
    standalone: false,
    selector: 'mbmenu',
    templateUrl: './mbmenu.component.html'
})

export class MbMenuComponent implements OnInit {

    @Input() menuList: WebMenuNode = null; // 主選單

    /** 是否點擊了header的mb menu 事件 */
    @Input() clickHeaderEvent: boolean = true;

    @Output() onClick: EventEmitter<any> = new EventEmitter();

    constructor(
        public el: ElementRef, public domHandler: DomHandler,
        private router: Router,
        private validatorService: ValidatorService,
        private axthenticationService: AxthenticationService,
        private statusService: StatusService) {
    }

    ngOnInit() {
        this.menuList = this.axthenticationService.menu;
    }

    toggleMainMenu(event: Event, menu: WebMenuNode) {
        event.preventDefault();
        // 觸發元件的body click事件，讓它們隱藏，如dropdown、calendar
        document.body.click();

        // 關閉所有的Javascript產生的popup
        closeAllPopupPanel();

        try {
            const target = event.target as HTMLElement;
            if (target && typeof (target.focus) === 'function') {
                target.focus();
            }

        } catch (e) { }

        // console.log(',menu.menuIxd=' + menu.menuIxd + ',menu.expand=' + menu.expand);

        menu.expand = !menu.expand;
        //  event.preventDefault();
    }

    /**
     * 點擊menu
     * @param event
     * @param clickmenu
     */
    toggleSubMainMenu(event: Event, clickmenu: WebMenuNode) {
        event.preventDefault();
        let haveLeaf: boolean = clickmenu.children.length > 0;
        if (haveLeaf) {
            // 畫面展開
            clickmenu.expand = !clickmenu.expand;
            /*
                        if (clickmenu.display === 'none') {
                            clickmenu.display = '';
                            clickmenu.styleClass = 'tre_nav on';
                        } else {
                            clickmenu.display = 'none';
                            clickmenu.styleClass = 'tre_nav';
                        }
                        */
        } else {

            let eventData: EventData = new EventData(event, clickmenu.url, true, null);

            eventData.taskID = clickmenu.taskIxd;

            clickmenu.areaType = this.axthenticationService.currentArea;

            eventData.originalEvent = clickmenu;
            // 進行click動作
            this.onClick.emit(eventData);
        }
        //  event.preventDefault();
    }


}
